var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 12.5537C22 18.0767 17.523 22.5537 12 22.5537C6.477 22.5537 2 18.0767 2 12.5537C2 7.03171 6.477 2.55371 12 2.55371C17.523 2.55371 22 7.03171 22 12.5537Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5086 12.2471C12.32 12.2471 12.167 12.6294 12.167 13.1004C12.167 13.5731 12.32 13.9554 12.5086 13.9554C12.6974 13.9554 12.8505 13.573 12.8505 13.1004C12.8505 12.6294 12.6974 12.2471 12.5086 12.2471Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5071 16.5192C11.7521 16.5192 11.14 14.9881 11.14 13.1009C11.14 11.2137 11.7521 9.68349 12.5071 9.68349C12.5091 9.68349 12.5112 9.68369 12.5131 9.6838C13.2653 9.69207 13.8741 11.2186 13.8741 13.1009C13.8741 14.9881 13.2621 16.5192 12.5069 16.5192H12.5071ZM12.4259 9C11.8856 9 11.3943 9.41792 11.028 10.1011C10.4833 10.4326 9.92164 10.6804 9.36059 10.8626C8.84039 11.0333 8.40952 11.3696 8.12114 11.8029C7.50195 11.8029 7 12.3051 7 12.9254V13.2799C7 13.9003 7.50195 14.4024 8.12114 14.4024H8.12157C8.41069 14.8356 8.84304 15.1737 9.36462 15.3443C9.92323 15.5249 10.4827 15.7709 11.0263 16.1041C11.3927 16.7884 11.8848 17.2052 12.426 17.2052V17.2037C13.5586 17.2037 14.4766 15.3674 14.4766 13.101C14.4766 10.8365 13.5586 9.0001 12.426 9.0001L12.4259 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerIcon);
export default __webpack_public_path__ + "static/media/speaker_icon.095e2e2bf51921335f8618284023f765.svg";
export { ForwardRef as ReactComponent };